import React from "react";

export default function TransitionArrowIcon({ className = "svg-90", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 41 8" fill="none" className={className} aria-hidden="true" {...props}>
      <path
        d="M40.3536 4.03544C40.5488 3.84018 40.5488 3.52359 40.3536 3.32833L37.1716 0.146351C36.9763 -0.0489113 36.6597 -0.0489113 36.4645 0.146351C36.2692 0.341613 36.2692 0.658195 36.4645 0.853458L39.2929 3.68188L36.4645 6.51031C36.2692 6.70557 36.2692 7.02216 36.4645 7.21742C36.6597 7.41268 36.9763 7.41268 37.1716 7.21742L40.3536 4.03544ZM0 3.68188V4.18188H40V3.68188V3.18188H0V3.68188Z"
        fill="currentColor"
      />
    </svg>
  );
}
